import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getSetting({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation_coef_setting.setting'), payload)
    if (apiResult.success && apiResult.data) {
      return apiResult.data
    }
    return false
  },
  async update({ commit }, payload) {
    return await apiService.post(route('member.fcs.simulation_coef_setting.update'), payload)
  },
}

export default {
  state,
  mutations,
  actions,
}
